'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Button } from '../ui/button';
import { FaFacebook } from 'react-icons/fa';

export function BlogShare({ blog }: { blog: Blog }) {
  const handleShare = () => {
    const shareUrl = `${window.location.origin}/blog/${blog.slug}`;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      shareUrl,
    )}`;
    window.open(facebookShareUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={cn('w-full max-w-[792px] pr-4 sm:pr-0', 'flex items-center justify-end')}>
      <Button variant={'primary-foreground'} className="w-full sm:w-fit" onClick={handleShare}>
        <FaFacebook size={24} /> Zdieľať na Facebooku
      </Button>
    </div>
  );
}
